'use client'
import { IconButton, Select, styled } from '@mui/material'

// Styled components for custom styling
export interface StyledIconButtonProps {
  selected?: boolean
}

export const StyledIconButton = styled(IconButton)<StyledIconButtonProps>(({ theme, selected }) => ({
  border: selected ? `1px solid ${theme.palette.primary.main}` : `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1),
  // Use theme colors for selected state
  backgroundColor: selected
    ? `${theme.palette.primary.main}15` // 15% opacity
    : 'transparent',
  color: selected ? theme.palette.primary.main : theme.palette.text.primary,
  '&:hover': {
    backgroundColor: selected
      ? `${theme.palette.primary.main}25` // 25% opacity on hover
      : theme.palette.action.hover,
    borderColor: theme.palette.primary.main,
  },
  // Smooth transitions
  transition: theme.transitions.create(['background-color', 'border-color', 'color'], {
    duration: theme.transitions.duration.shorter,
  }),
}))

export const StyledSelect = styled(Select)(({ theme }) => ({
  minWidth: 96,
  height: 36,
  '& .MuiSelect-select': {
    padding: theme.spacing(1),
  },
  '& .MuiSvgIcon-root': {
    color: theme.palette.primary.main,
  },
}))
